import styled from 'styled-components';
import { alpha } from '../../../themes/brand';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  
  @media (max-width: 1024px) {
    padding: 16px;
  }
  
  @media (max-width: 768px) {
    padding: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 500px;
  background-color: ${props => props.theme.formUserBackground};
  border-radius: 14px;
  padding: 28px;
  border: 1px solid ${props => props.theme.formUserBorder};
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin-bottom: 24px;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const InputGroupSmall = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const Label = styled.label`
  color: ${props => props.theme.inputAddEditRule};
  font-size: 14px;
  
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 500;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${props => props.theme.inputAddEditRule};
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.primary, 0.2)};
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 14px;
    font-size: 16px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
    font-size: 14px;
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 120px;
  padding: 12px 14px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${({ theme }) => theme.primaryAccent};
  font-size: 14px;
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.primary, 0.2)};
  }
`;

export const InputSmall = styled.input`
  width: 100%;
  padding: 12px 14px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${({ theme }) => theme.primaryAccent};
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.primary, 0.2)};
  }
`;

export const InputRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 16px;
  background: linear-gradient(135deg, ${({ theme }) => theme.primary} 0%, ${({ theme }) => theme.primaryHover} 100%);
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  box-shadow: 0 8px 20px ${({ theme }) => alpha(theme.primary, 0.25)};

  &:hover {
    transform: translateY(-1px);
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  top: 80px;
  left: 24px;
  z-index: 1;
  
  @media (max-width: 768px) {
    left: 12px;
    top: 60px;
  }
  
  @media (max-width: 480px) {
    left: 8px;
    top: 50px;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  .icon {
    color: ${({ theme }) => theme.arrowBack};
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(-2px);
  }
`;

export const Select = styled.select`
  width: 95%;
  padding: 12px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${({ theme }) => theme.primaryAccent};
  font-size: 14px;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%238FB0CC' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
  }
`;

// Componentes para a tela de Regra XPTO
export const XPTOContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 95%;
  position: relative;
  padding: 0;
  box-sizing: border-box;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 16px;
  }
  
  @media (max-width: 480px) {
    margin-top: 12px;
  }
`;

export const XPTOTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: ${props => props.theme.text};
  
  @media (max-width: 1024px) {
    font-size: 1.4rem;
  }
  
  @media (max-width: 768px) {
    font-size: 1.3rem;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    font-size: 1.2rem;
    margin-bottom: 0.8rem;
  }
`;

export const XPTODescription = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
  line-height: 1.5;
  color: ${props => props.theme.text};
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    margin-bottom: 1.2rem;
  }
`;

export const XPTOTextArea = styled.textarea`
  width: 95%;
  height: 50vh;
  padding: 1rem;
  /* Antes: detectava o tema comparando \`theme.primary === '#0F1A24'\` e escolhia hex chumbado
     para cada caso. A comparação quebrava a cada troca de paleta, e escondia que o problema
     real era \`primary\` servir de fundo e de texto ao mesmo tempo. Agora usa tokens. */
  background-color: ${props => props.theme.ruleDetailsInputBackground};
  border: 1px solid ${props => props.theme.ruleDetailsInputBorder};
  border-radius: 8px;
  color: ${props => props.theme.text};
  font-size: 1rem;
  resize: none;
  margin-bottom: 4rem;

  &::placeholder {
    color: ${props => props.theme.placeholderColor};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.primaryAccent};
  }
  
  @media (max-width: 1024px) {
    width: 100%;
    height: 45vh;
    margin-bottom: 3rem;
  }
  
  @media (max-width: 768px) {
    height: 40vh;
    padding: 0.8rem;
    font-size: 0.9rem;
    margin-bottom: 2rem;
  }
  
  @media (max-width: 480px) {
    height: 35vh;
    padding: 0.6rem;
    font-size: 0.85rem;
    margin-bottom: 1.5rem;
  }
`;

export const XPTOSaveButton = styled.button`
  padding: 0.75rem 2rem;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  align-self: flex-end;
  margin-bottom: 0;
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
  
  @media (max-width: 768px) {
    align-self: center;
    width: 100%;
    max-width: 300px;
    padding: 1rem 2rem;
    font-size: 1.1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    max-width: 250px;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  padding: 0 2rem;
  
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0 0.5rem;
  }
`;